import script from "./MarketingDatatableTDPatientsCount.vue?vue&type=script&setup=true&lang=js"
export * from "./MarketingDatatableTDPatientsCount.vue?vue&type=script&setup=true&lang=js"

import "./MarketingDatatableTDPatientsCount.vue?vue&type=style&index=0&id=153677bd&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-153677bd"]])

export default __exports__